// extracted by mini-css-extract-plugin
export var contentBody = "_5g-9";
export var headerImage = "_5g-2";
export var imageButton = "_5g-7";
export var imageButtonIcon = "_5g-8";
export var imageHeader = "_5g-4";
export var imageHeaderText = "_5g-5";
export var imageOverlay = "_5g-3";
export var imageTitle = "_5g-6";
export var imageWrapper = "_5g-1";
export var taskList = "_5g-a";
export var widget = "_5g-0";